import React from "react";
import { SelectProps } from "../types";
import { SelectMultiple } from "./SelectMultiple";
import { SelectSingle } from "./SelectSingle";
import { SelectMultipleCheckbox } from "./SelectMultipleCheckbox";

export const Select = React.forwardRef<unknown, SelectProps>((
  props,
  ref /* ref prop required by Material Ui*/
) => {
  const { selectVariant, ...coreProps } = props;
  switch (props.selectVariant) {
    case "multiple":
      return <SelectMultiple {...coreProps} />;
    case "checkboxes":
      return <SelectMultipleCheckbox {...coreProps} />;
    default:
      return <SelectSingle {...coreProps} />;
  }
});
